module.exports = __webpack_public_path__ + "static/media/eye.1e0ab340.svg";